import { render, staticRenderFns } from "./aside-button.vue?vue&type=template&id=5f362769&scoped=true"
import script from "./aside-button.vue?vue&type=script&lang=js"
export * from "./aside-button.vue?vue&type=script&lang=js"
import style0 from "./aside-button.vue?vue&type=style&index=0&id=5f362769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f362769",
  null
  
)

export default component.exports